<script lang="ts">
  let paused: boolean;
</script>

<div class="px-4 py-16 mx-auto w-full md:px-24 lg:px-8 lg:py-16 bg-gray-200">
  <div class="max-w-xl sm:mx-auto lg:max-w-2xl">
    <div class="flex flex-col sm:text-center sm:mb-0">
      <div
        class="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
        <h2
          class="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto">
          <span class="relative hidden sm:inline-block"><svg
              viewBox="0 0 52 24"
              fill="currentColor"
              class="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-blue-gray-100 lg:w-32 lg:-ml-28 lg:-mt-10 sm:block">
              <defs>
                <pattern
                  id="e77df901-b9d7-4b9b-822e-16b2d410795b"
                  x="0"
                  y="0"
                  width=".135"
                  height=".30">
                  <circle cx="1" cy="1" r=".7" />
                </pattern>
              </defs>
              <rect
                fill="url(#e77df901-b9d7-4b9b-822e-16b2d410795b)"
                width="52"
                height="24" /></svg></span>
          Sync your crypto with YNAB
        </h2>
        <p class="text-base text-gray-700 md:text-lg">
          Connects to exchanges and wallets, syncs them together.
        </p>
      </div>
      <div>
        <a
          href="#app-main"
          class="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-indigo-500 hover:bg-indigo-500 focus:shadow-outline focus:outline-none">
          Get started now.
        </a>
      </div>
      <p class="mt-6">See how it works in action</p>
      <div
        class="mt-6 rounded-3xl overflow-hidden border-gray-400 border-2 shadow-2xl">
        <!-- svelte-ignore a11y-media-has-caption -->
        <video
          src="video.webm"
          loop
          autoplay
          muted
          bind:paused
          on:click={() => (paused = !paused)} />
      </div>
    </div>
  </div>
</div>
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<div class="px-4 py-16 mx-auto w-full md:px-24 lg:px-8 lg:py-20 bg-white">
  <div class="p-8 rounded shadow-xl sm:p-16 max-w-6xl mx-auto">
    <div class="flex flex-col lg:flex-row">
      <div class="mb-6 lg:mb-0 lg:w-1/2 lg:pr-5">
        <h2
          class="font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
          You keep track of your budget. We’ll help you balance your crypto
          wallet.
        </h2>
      </div>
      <div class="lg:w-1/2">
        <p class="mb-4 text-base text-gray-700">
          You're an expert at managing money, but the world of cryptocurrency is
          tough to navigate alone. That's why we created Crypto Syncer—a tool
          that helps you sync the balance of your crypto currency wallet,
          exchange it to fiat money and then sync the balance to your YNAB
          account so you can make smarter decisions about how much Bitcoin or
          Ethereum you should buy today based on what will be worth more
          tomorrow.
        </p>
        <a
          href="#app-main"
          aria-label=""
          class="inline-flex items-center font-semibold transition-colors duration-200 text-indigo-500 hover:text-indigo-500">Get
          Started</a>
      </div>
    </div>
  </div>
</div>
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<div class="px-4 py-16 mx-auto bg-white w-full md:px-24 lg:px-8 lg:py-20">
  <div class="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
    <h2
      class="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto">
      Money in sync.
    </h2>
    <p class="text-base text-gray-700 md:text-lg">
      Use your budgeting app to keep track of all your money, including
      cryptocurrency balances.
    </p>
  </div>
  <div class="grid max-w-screen-lg gap-8 row-gap-10 mx-auto lg:grid-cols-2">
    <div class="flex flex-col max-w-md sm:mx-auto sm:flex-row">
      <div class="mr-4">
        <div
          class="flex items-center justify-center w-12 h-12 mb-4 rounded-full bg-indigo-100">
          <svg
            stroke="currentColor"
            viewBox="0 0 52 52"
            class="w-10 h-10 text-indigo-500">
            <polygon
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              points="29 13 14 29 25 29 23 39 38 23 27 23" />
          </svg>
        </div>
      </div>
      <div>
        <h6 class="mb-3 text-xl font-bold leading-5 text-gray-900">
          Keep up with the markets without over-complicating things.
        </h6>
        <p class="mb-3 text-sm text-gray-700">
          Allowing you to make better decisions by knowing the current value of
          each currency you own and how much is on hand for use.
        </p>
        <a
          href="#app-main"
          aria-label=""
          class="inline-flex items-center font-semibold text-indigo-500 transition-colors duration-200 hover:text-indigo-500">Learn
          more</a>
      </div>
    </div>
    <div class="flex flex-col max-w-md sm:mx-auto sm:flex-row">
      <div class="mr-4">
        <div
          class="flex items-center justify-center w-12 h-12 mb-4 rounded-full bg-indigo-100">
          <svg
            stroke="currentColor"
            viewBox="0 0 52 52"
            class="w-10 h-10 text-indigo-500">
            <polygon
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              points="29 13 14 29 25 29 23 39 38 23 27 23" />
          </svg>
        </div>
      </div>
      <div>
        <h6 class="mb-3 text-xl font-bold leading-5 text-gray-900">
          Your finances, in one place.
        </h6>
        <p class="mb-3 text-sm text-gray-700">
          You can also view your crypto balance as a part of your total net
          worth and see how it changes from day to day (or hour).
        </p>
        <a
          href="#app-main"
          aria-label=""
          class="inline-flex items-center font-semibold text-indigo-500 transition-colors duration-200 hover:text-indigo-500">Learn
          more</a>
      </div>
    </div>
  </div>
</div>
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->
<!---->

<div class="max-w-5xl mx-auto">
  <main
    id="app-main"
    class="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
    <div class="sm:text-center lg:text-left pb-4">
      <slot />
    </div>
  </main>
</div>

<div class="bg-gray-100 px-4 pt-16 mx-auto w-full border-opacity-10">
  <div class="max-w-6xl mx-auto mb-8 text-center">
    <a
      href="/"
      aria-label="Go home"
      title="Company"
      class="inline-flex items-center"><svg
        viewBox="0 0 24 24"
        stroke-linejoin="round"
        stroke-width="2"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke="currentColor"
        fill="none"
        class="w-8 text-indigo-500">
        <rect x="3" y="1" width="7" height="12" />
        <rect x="3" y="17" width="7" height="6" />
        <rect x="14" y="1" width="7" height="6" />
        <rect x="14" y="11" width="7" height="12" />
      </svg>
      <span
        class="ml-2 text-xl font-bold tracking-wide text-gray-900 uppercase">Crypto
        Syncer for YNAB</span></a>
    <div class="mt-6 lg:max-w-md mx-auto">
      <p class="text-sm text-gray-900">
        This is a tool that helps you sync the balance of your crypto currency
        wallet, exchange it to fiat money and then sync the balance to your YNAB
        account.
      </p>
    </div>
    <div class="mt-6 lg:max-w-2xl mx-auto text-xs" id="privacy">
      <span class="text-lg text-gray-900 mb-2">Privacy Policy</span>
      <p class="text-gray-700 mb-1">
        I
        <strong>do not</strong>
        track your personal information.
      </p>
      <p class="text-gray-700 mb-1">
        I use Google Analytics to understand how the site is used.
      </p>
      <p class="text-gray-700 mb-1">
        I use YNAB api to make this app work. For that, if you decide to create
        an importer, I save the account id, the balance id and the currency of
        your balance. The list of all your accounts and budgets is not stored on
        my servers and only fetched from YNAB on demand. During your visit on
        this site, the names of your budgets and accounts are stored directly in
        your browser and removed automatically after the session ends.
      </p>
      <p class="text-gray-700 mb-1">
        This project is hosted on Firebase (Google).
      </p>
    </div>
  </div>
  <div class="max-w-6xl mx-auto pt-5 pb-10 border-t">
    <p class="text-sm text-gray-700 text-center">
      Made with ❤️️ by
      <a
        class="underline text-blue-500"
        target="_blank"
        href="https://twitter.com/theluk246">theluk</a>
    </p>
    <p class="text-sm text-gray-700 text-center">
      © Copyright 2021
      <a
        class="underline text-blue-500"
        target="_blank"
        href="https://twitter.com/theluk246">theluk</a>. All rights reserved.
    </p>
  </div>
</div>
